import React, { Component, useState, useCallback, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { Dropdown, NavLink } from "react-bootstrap";
import Scrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import foodtechlogo from "../../assets/img/foodtech/foodtech-logo-84x41.png";
import { useDispatch, useSelector } from "react-redux";
// import debounce from "lodash.debounce";
import { getProfileDetails } from "../../redux/slices/Registration";
// import { getNewOrderFromSocket } from '../../util/fn';
import { toast } from "react-toastify";
import persistStore from "redux-persist/es/persistStore";
import { persistor } from "../../redux/store";
import { CiSaveDown2 } from "react-icons/ci";
import AudioFile from "../../assets/audio/audio.mp3";
import { getSocket } from "../../util/socket";

const Topnavigation = () => {

    const audioRef = useRef(null);
    const soundEnabledRef = useRef(false);
    const vendorId = localStorage.getItem("vendorId") || "";

  const addsidenavigation = () => {
    $(".ms-body").toggleClass("ms-aside-left-open");
    $("#ms-side-nav").toggleClass("ms-aside-open");
    $(".ms-aside-overlay.ms-overlay-left").toggleClass("d-block");
  };
  const topbaropen = () => {
    $("#ms-nav-options").toggleClass("ms-slide-down");
  };
  const { user, profile } = useSelector((state) => state.register);
  const [image, setImage] = useState();
  const [soundEnabled, setSoundEnabled] = useState(false);
  const socket = getSocket();

  const dispatch = useDispatch();

  // useEffect(() => {
  //     const socket = getNewOrderFromSocket(localStorage.getItem('orderOutletId'));
  //     if (socket) {
  //         socket.on("newOrderNotification", (data) => {
  //             console.log('newOrderNotification',data)
  //           if(data){

  //             toast.success(data)
  //           }
  //         });
  //       }
  //       return () => {
  //         socket.off("newOrderNotification");
  //       };
  // },[])

  useEffect(() => {
    setImage(profile?.image);
  }, [profile]);
  useEffect(() => {
    dispatch(
      getProfileDetails({
        vendorId: localStorage.getItem("vendorId"),
      })
    );
  }, [dispatch]);

   useEffect(() => {
      audioRef.current = new Audio(AudioFile);
      audioRef.current.preload = "auto";

      setSoundEnabled(false);
      soundEnabledRef.current = false;

      return () => {
        audioRef.current?.pause();
      };
    }, []);

    const toggleSound = async () => {
      if (soundEnabled) {
        setSoundEnabled(false);
        soundEnabledRef.current = false;
        return;
      }

      try {
        const audio = audioRef.current;

        if (!audio) return;

        audio.muted = true;
        await audio.play();

        audio.pause();
        audio.currentTime = 0;
        audio.muted = false;

        soundEnabledRef.current = true;
        setSoundEnabled(true);

        toast.success("Order notification sound enabled!");
      } catch (error) {
        if (audioRef.current) {
          audioRef.current.muted = false;
        }

        soundEnabledRef.current = false;
        setSoundEnabled(false);

        toast.error("Unable to enable sound. Please try again.");
      }
    };


    const handlePlay = async () => {
      if (!soundEnabledRef.current || !audioRef.current) return;

      try {
        audioRef.current.currentTime = 0;
        await audioRef.current.play();
      } catch (error) {
        console.error("Error playing audio:", error);
      }
    };

    useEffect(() => {
      if (!socket) return;

      socket.on("newOrderAlert",  (data) => {
          if (soundEnabledRef.current) {
            handlePlay();
          } else {
            toast.info(
              "New order received! Enable notification sound to hear order alerts."
            );
          }
          toast.success(data);
      });

      return () => {
        socket.off("newOrderAlert");
      };
        
    }, [socket]);

  const DownloadMou = async () => {};

  return (
    <nav className="navbar ms-navbar">
      <div
        className="ms-aside-toggler ms-toggler pl-0"
        onClick={addsidenavigation}
      >
        <span className="ms-toggler-bar bg-primary" />
        <span className="ms-toggler-bar bg-primary" />
        <span className="ms-toggler-bar bg-primary" />
      </div>
      <div className="logo-sn logo-sm ms-d-block-sm">
        {/* <Link className="pl-0 ml-0 text-center navbar-brand mr-0" to="/">
          <img src={foodtechlogo} alt="logo" />{" "}
        </Link> */}
      </div>
      <ul className="ms-nav-list ms-inline mb-0" id="ms-nav-options">
        <li className="ms-nav-item ms-search-form pb-0 py-0 cursor-pointer">
          <Link to="/get-mou">
            <span className="red-color">MOU</span>
            {/* <CiSaveDown2 onClick={DownloadMou} fontSize={"25px"} /> */}
            <CiSaveDown2 fontSize={"25px"} />
          </Link>
        </li>
        <li className="ms-nav-item sound-nav-item">
          <button
            type="button"
            className={`sound-switch ${soundEnabled ? "is-on" : "is-off"}`}
            onClick={toggleSound}
            role="switch"
            aria-checked={soundEnabled}
            title={soundEnabled ? "Disable notification sound" : "Enable notification sound"}
          >
            <span className="sound-switch-track">
              <span className="sound-switch-knob" />
            </span>

            <span className="sound-switch-label">
              {soundEnabled ? "ON" : "OFF"}
            </span>
          </button>
        </li>
        {/* <li className="ms-nav-item ms-search-form pb-0 py-0">
                    <form className="ms-form" method="post">
                        <div className="ms-form-group my-0 mb-0 has-icon fs-14">
                            <input type="search" className="ms-form-input" name="search" placeholder="Search here..." /> <i className="flaticon-search text-disabled" />
                        </div>
                    </form>
                </li> */}
        {/* 
                <li className="ms-nav-item dropdown">
                    <Dropdown className="custom-dropdown">
                        <Dropdown.Toggle as={NavLink} className="text-disabled ms-has-notification p-0"><i className="flaticon-bell" /></Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu dropdown-menu-right" aria-labelledby="notificationDropdown">
                            <div className="dropdown-menu-header">
                                <h6 className="dropdown-header ms-inline m-0"><span className="text-disabled">Notifications</span></h6><span className="badge badge-pill badge-info">2 New</span>
                            </div>
                            <div className="dropdown-divider" />
                            <Scrollbar className="ms-scrollable ms-dropdown-list">
                                <Link className="media p-2" to="#">
                                    <div className="media-body"> <span>New Order Received</span>
                                        <p className="fs-10 my-1 text-disabled"><i className="material-icons">access_time</i> 30 seconds ago</p>
                                    </div>
                                </Link>

                                <Link className="media p-2" to="#">
                                    <div className="media-body"> <span>New Order Received</span>
                                        <p className="fs-10 my-1 text-disabled"><i className="material-icons">access_time</i> 2 hours ago</p>
                                    </div>
                                </Link>

                            </Scrollbar>
                            <div className="dropdown-divider" />
                            <div className="dropdown-menu-footer text-center"> <Link to="#">View all Notifications</Link>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </li> */}
        <li className="ms-nav-item ms-nav-user dropdown">
          <Dropdown className="custom-dropdown">
            <Dropdown.Toggle as={NavLink} id="userDropdown" className="p-0">
              <img
                className="ms-user-img ms-img-round"
                src={
                  image
                    ? image
                    : "data:image/png;base64,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"
                }
                alt="people"
              />
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="dropdown-menu dropdown-menu-right user-dropdown"
              aria-labelledby="userDropdown"
            >
              <div className="dropdown-menu-header">
                <h6 className="dropdown-header ms-inline m-0">
                  <span className="text-disabled">
                    Welcome, {user ? user : ""}
                  </span>
                </h6>
              </div>
              <div className="dropdown-divider" />
              <div className="ms-dropdown-list">
                <Link className="media fs-14 p-2" to="/user-profile">
                  {" "}
                  <span>
                    <i className="flaticon-user mr-2" /> Profile
                  </span>
                </Link>
              </div>
              <div className="dropdown-divider" />

              <div className="dropdown-menu-footer">
                <a
                  className="media fs-14 p-2"
                  href="/login"
                  onClick={(e) => {
                    e.preventDefault();
                    localStorage.clear();
                    localStorage.removeItem("isLoggedIn");
                    localStorage.removeItem("outletId");
                    localStorage.removeItem("vendorId");
                    localStorage.removeItem("vendorType");
                    localStorage.removeItem("user");
                    localStorage.removeItem("persist:root");

                    // Clear all local storage
                    localStorage.clear();

                    // Purge persisted state
                    persistor.purge().then(() => {
                      // Redirect to login page
                      window.location.href = "/login";
                    });
                  }}
                >
                  {" "}
                  <span>
                    <i className="flaticon-shut-down mr-2" /> Logout
                  </span>
                </a>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </li>
      </ul>
      <div
        className="ms-toggler ms-d-block-sm pr-0 ms-nav-toggler"
        onClick={topbaropen}
      >
        <span className="ms-toggler-bar bg-primary" />
        <span className="ms-toggler-bar bg-primary" />
        <span className="ms-toggler-bar bg-primary" />
      </div>
    </nav>
  );
};

export default Topnavigation;
